import React, {useEffect, useState} from "react";
import homeStyle from "../main/home.scss";
import style from "./itineraries.scss";
import {Menu} from "../menu/menu";
import {Spinner} from "../controls/spinner";
import {conversationApi} from "../api/conversationApi";
import {Button} from "../controls/button";
import {Link} from "react-router-dom";

export function Itineraries() {
  const [itineraries, setItineraries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [creatingItinerary, setCreatingItinerary] = useState(false);
  
  useEffect(() => {
    loadItineraries();
  }, []);
  
  async function loadItineraries() {
    setLoading(true);
    setItineraries(await conversationApi.getAllItineraries());
    setLoading(false);
  }
  
  return (
    <div className={homeStyle.home}>
      <Menu/>
      <div className={homeStyle.rightSidePanel}>
        <div className={homeStyle.list}>
          <Button onClick={createItinerary} disabled={creatingItinerary} noArrow>
            {creatingItinerary ? <Spinner/> : "Add"}
          </Button>
          {loading && <Spinner/>}
          {!loading && itineraries.sort((i1, i2) => i1.name > i2.name ? 1 : -1).map(i =>
            <div className={style.itinerary} key={i._id}>
              <Link to={`/itineraries/${i._id}`}>
                {i.name}
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
  
  async function createItinerary() {
    setCreatingItinerary(true);
    await conversationApi.createItinerary({steps: [], name: "New itinerary", isActive: false});
    loadItineraries();
    setCreatingItinerary(false);
  }  
}